import { useEffect, useState } from "react";
import { fetchOneOrganization } from "../../api/application/organization";
import type { Organization } from "../../api/infrastructure/organization.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";
import { showToast } from "../shared/global-tools/toast-system";

export default function useGetOrganization({
  id,
  preloadData = true,
}: {
  id?: string;
  preloadData?: boolean;
} = {}) {
  const [organization, setOrganization] = useState<Organization>();
  const [loading, setLoading] = useState<boolean>(false);

  const fetchOrganization = async (id: string) => {
    setLoading(true);
    await apiRequestWrapper(async () => {
      try {
        const result = await fetchOneOrganization(id);
        setOrganization(result);
      } catch (error) {
        console.error("Error fetching organization:", error);
        showToast("Error fetching organization", { severity: "error" });
      } finally {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    if (!preloadData) return;
    if (!id) return;
    fetchOrganization(id);
  }, [id, preloadData]);

  return {
    organization,
    loadingOrganization: loading,
    fetchOrganization,
    setOrganization,
  };
}
